(function () {
  "use strict";

  function $(id) {
    return document.getElementById(id);
  }

  function initFunnelTimer() {
    var els = document.querySelectorAll("#nl-yo-timer");
    if (!els.length) return;
    var key = "nl_funnel_timer_v1";
    var end = Number(sessionStorage.getItem(key) || 0);
    if (!end || end < Date.now()) {
      end = Date.now() + 19 * 60 * 1000 + 45000;
      sessionStorage.setItem(key, String(end));
    }
    function paint() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      var t = (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
      els.forEach(function (el) {
        el.textContent = t;
      });
    }
    paint();
    setInterval(paint, 1000);
  }

  function initViewers() {
    var els = document.querySelectorAll("#nl-yo-viewers");
    if (!els.length) return;
    function paint() {
      var n = String(52 + Math.floor(Math.random() * 41));
      els.forEach(function (el) {
        el.textContent = n;
      });
    }
    paint();
    setInterval(paint, 12000);
  }

  function initMobileBar() {
    var bar = $("nl-funnel-m-bar");
    if (!bar) return;
    var body = document.body;
    function toggle() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var pastHalf = maxScroll > 0 && y / maxScroll >= 0.5;
      if (pastHalf) {
        bar.removeAttribute("hidden");
        if (body) body.classList.add("nl-funnel-m-bar-visible");
      } else {
        bar.setAttribute("hidden", "");
        if (body) body.classList.remove("nl-funnel-m-bar-visible");
      }
    }
    window.addEventListener("scroll", toggle, { passive: true });
    window.addEventListener("resize", toggle, { passive: true });
    toggle();
    bar.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        if (window.NLTracking && window.NLTracking.track) {
          window.NLTracking.track("Lead", { content_name: "Mobile sticky CTA" });
        }
      });
    });
  }

  function boot() {
    initFunnelTimer();
    initViewers();
    initMobileBar();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
